import React, { useEffect, useState } from "react";

import Footer from "../../../../components/common/Footer";
import PageHeading from "../../../../components/common/PageHeading";
import RightBar from "../../../../components/common/RightBar";
import RightBarMethod from "../../../../components/common/RightBar/RightBarMethod";

import {
  allAgreements,
  outForSigningAgreements,
  printedAgreements,
  readyToCountersignAgreements,
} from "../../../../data/people";

import { Col, Radio, Row, Table } from "antd";

const ManagementAgreementsRightSideBar = [
  RightBarMethod("TASKS", "t1", <i className="fa-solid fa-star"></i>, [
    RightBarMethod("Management Agreement Templates", "1", "", "", ""),
    RightBarMethod("New Management Agreement", "2", "", "", ""),
  ]),
  RightBarMethod(
    "HELP TOPICS",
    "t2",
    <i className="fa-solid fa-circle-question"></i>,
    [RightBarMethod("Management Agreements", "3", "", "", "")]
  ),
];

function ManagementAgreements() {
  const [value, setValue] = useState("all");
  const [tableData, setTableData] = useState([]);
  const [sortedInfo, setSortedInfo] = useState({});

  const handleChange = (sorter) => {
    setSortedInfo(sorter);
  };

  useEffect(() => {
    if (value === "all") {
      setTableData(allAgreements);
    } else if (value === "ready to countersign") {
      setTableData(readyToCountersignAgreements);
    } else if (value === "out for signing") {
      setTableData(outForSigningAgreements);
    } else if (value === "printed") {
      setTableData(printedAgreements);
    }
  }, [value]);

  const columns = [
    {
      title: "Signers",
      dataIndex: "signers",
      key: "signers",
      sorter: (a, b) => a.signers.length - b.signers.length,
      sortOrder: sortedInfo.columnKey === "signers" ? sortedInfo.order : null,
    },
    {
      title: "Agreement Generation Date",
      dataIndex: "agreementGenerationDate",
      key: "agreementGenerationDate",
      sorter: (a, b) =>
        a.agreementGenerationDate.length - b.agreementGenerationDate.length,
      sortOrder:
        sortedInfo.columnKey === "agreementGenerationDate"
          ? sortedInfo.order
          : null,
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      sorter: (a, b) => a.status.length - b.status.length,
      sortOrder: sortedInfo.columnKey === "status" ? sortedInfo.order : null,
    },
    {
      title: "Action",
      key: "action",
      render: () => <span className="onclick-text">View</span>,
    },
  ];

  return (
    <>
      <div className="page-container">
        <div className="main-container">
          <div className="management-agreements">
            <PageHeading heading="Management Agreements" />
            <Row gutter={[0, 24]}>
              <Col span={24}>
                <Radio.Group
                  value={value}
                  onChange={(e) => setValue(e.target.value)}
                >
                  <Radio.Button value="all">All</Radio.Button>
                  <Radio.Button value="ready to countersign">
                    Ready to Countersign
                  </Radio.Button>
                  <Radio.Button value="out for signing">
                    Out for Signing
                  </Radio.Button>
                  <Radio.Button value="printed">Printed</Radio.Button>
                </Radio.Group>
              </Col>
              {tableData.length >= 1 ? (
                <Col className="table-container" span={24}>
                  <Table
                    columns={columns}
                    dataSource={tableData}
                    onChange={handleChange}
                  />
                </Col>
              ) : (
                <Col span={24}>
                  <Row justify="center">
                    <Col>No management agreements found</Col>
                  </Row>
                </Col>
              )}
            </Row>
          </div>
          <Footer />
        </div>
      </div>
      <div className="RightSidebar">
        <RightBar RightBarData={ManagementAgreementsRightSideBar} />
      </div>
    </>
  );
}

export default ManagementAgreements;
